// extracted by mini-css-extract-plugin
export default {"cls1":"kfeqSpC0kuKajHa5K5oe","cls2":"byZgOJ7MhR71OoKOcyZV kfeqSpC0kuKajHa5K5oe"};